import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: AppLayoutComponent,
        children: [
          {
            path: 'home',
            canActivate: [AuthGuard],
            loadChildren: () =>
              import('./pages/home/home.module').then((m) => m.HomeModule),
          },
          {
            path: 'appointments',
            loadChildren: () =>
              import('./pages/appointments/appointment.routes').then(
                (m) => m.AppointmentRoutes,
              ),
          },
          {
            path: 'services',
            canActivate: [AuthGuard],
            loadChildren: () =>
              import('./pages/registers/services/service.routes').then(
                (r) => r.ServiceRoutes,
              ),
          },
          {
            path: 'clients',
            loadChildren: () =>
              import('./pages/registers/clients/client.routes').then(
                (r) => r.ClientRoutes,
              ),
          },
          {
            path: 'resources',
            loadChildren: () =>
              import('./pages/registers/resources/resource.routes').then(
                (r) => r.ResourceRoutes,
              ),
          },
          {
            path: 'schedule-settings',
            loadChildren: () => import('./pages/schedule-settings/schedule-settings.routes').then((r) => r.ScheduleSettingsRoutes),
          },
          { path: '', redirectTo: 'home', pathMatch: 'full' },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Bloqueia a renderização inicial até o Guard decidir o destino
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
